import { useEffect, useMemo, useState } from 'react';
import { scrollIntoView } from 'seamless-scroll-polyfill';

export const useScroll = (id?: string, rootMaring?: string) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const ioConfiguration = {
    rootMargin: rootMaring || '-45% 0% -55% 0%',
    threshold: 0,
  };
  const observer = useMemo(
    () =>
      new IntersectionObserver(
        ([entry]) => setIsIntersecting(entry.isIntersecting),
        ioConfiguration
      ),
    [ioConfiguration]
  );

  const scrollToId = (destination: string, alternativeDestination?: string) => {
    const scrollElement =
      document?.getElementById(destination) ||
      (alternativeDestination && document?.getElementById(alternativeDestination));
    if (scrollElement) {
      return scrollIntoView(scrollElement, { behavior: 'smooth' });
    }
    return;
  };

  useEffect(() => {
    if (id) {
      const el = document.getElementById(id);
      if (el) {
        observer.observe(el);
      }
    }
    return () => {
      if (id) {
        observer.disconnect();
      }
    };
  }, [id, observer]);

  return { scrollToId, isIntersecting };
};
